<template>
    <v-container fluid class="pa-0 footer-class">
        <footer-address />
    </v-container>
</template>

<script>
    import Address from "./Address"

    export default {
        name: 'Footer',
        props: ['isCheckout'],
        components: {
            'footer-address': Address
        }
    }
</script>

<style lang="scss">
    .footer-class {
        background: linear-gradient(to left, #10529e 50%, #4b982b 50%);
        @media #{$pixel-less-phone} {
            background: #10529e;
        }
    }
</style>
